import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";
import LiteEditor from "lite-editor";
import ModalImageSelector from "./modal_image_selector";
import moment from "moment";

var editor;

export default createReactClass({
  displayName: "Root",
  PropTypes: {
    myCircle: PropTypes.object.isRequired,
    blog: PropTypes.object.isRequired,
    urlParam: PropTypes.string.isRequired,
  },
  getInitialState() {
    return {
      title: this.props.blog.title,
      content: this.props.blog.content,
      keyvisualUrl: this.props.blog.keyvisual_url,
      publishDatetime: moment(this.props.blog.publish_datetime).format(
        "YYYY-MM-DDTHH:mm:ss"
      ),
      publicType: this.props.blog.public_type,
      isDraft: this.props.blog.is_draft,
      isDeleted: false,
      isModalImageSelectorActive: false,
      tags: this.props.tags,
      caller: "",
    };
  },
  componentDidMount() {
    this.createEditor();
  },
  createEditor() {
    var handleModalImageSelector = this.handleModalImageSelector;

    const btnOptions = [
      {
        label: '<i class="fas fa-link"></i>',
        tag: "a",
        className: "",
        group: "mark",
      },
      {
        label: '<i class="fas fa-bold"></i>',
        tag: "strong",
        className: "",
        group: "mark",
      },
      {
        label: '<i class="fas fa-italic"></i>',
        tag: "i",
        className: "",
        group: "mark",
      },
    ];

    editor = new LiteEditor(".js-editor", {
      btnOptions: btnOptions,
      source: false,
      nl2br: true,
      escapeNotRegisteredTags: false,
      minHeight: 200,
      maxHeight: 100000,
      message: {
        addLinkTitle: "リンク挿入",
        updateLinkTitle: "リンク挿入",
        addLink: "挿入",
        updateLink: "挿入",
        linkUrl: "URL",
        linkLabel: "テキスト",
        closeLabel: "",
        targetBlank: "別タブ",
        targetBlankLabel: "別タブで開く",
      },
    });
    editor.registerButton({
      label: '<i class="fas fa-image" aria-hidden="true"></i>',
      group: "mark",
      action: "extra",
      onClick: function() {
        editor.saveSelection();
        handleModalImageSelector();
      },
    });
    editor.registerButton({
      label: "見出し",
      tag: "h2",
      className: "",
      group: "mark2",
      sampleText: "見出し",
    });
    editor.registerButton({
      label: "引用",
      tag: "blockquote",
      className: "",
      group: "mark2",
      sampleText: "引用",
    });
  },

  updateBlogToServer() {
    var content = document.getElementById("content").value;
    $.ajax({
      url: "/api/my_circle/blog/update",
      type: "POST",
      cache: false,
      headers: {
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
      },
      data: {
        id: this.props.blog.id,
        title: this.state.title,
        content: content,
        keyvisual_url: this.state.keyvisualUrl,
        publish_datetime: this.state.publishDatetime,
        public_type: this.state.publicType,
        is_draft: this.state.isDraft,
        is_deleted: this.state.isDeleted,
        tags: this.state.tags,
      },
    })
      .done(
        function() {
          window.location.href =
            "/my_circle/" + this.props.myCircle.id + "/blogs/";
        }.bind(this)
      )
      .fail(function() {}.bind(this));
  },
  handleTitleInput(e) {
    this.setState({
      title: e.target.value,
    });
  },
  handlePublishDatetimeInput(e) {
    this.setState({
      publishDatetime: e.target.value,
    });
  },
  handleTagsInput(e) {
    this.setState({
      tags: e.target.value,
    });
  },
  handleModalImageSelector() {
    this.setState({
      isModalImageSelectorActive: true,
    });
  },
  closeModal() {
    this.setState({
      isModalImageSelectorActive: false,
      caller: "",
    });
  },
  selectPhoto(e) {
    var insertHtml =
      '<img src="' +
      e.target.value +
      '" style="width: 100%; max-width: 340px;">';
    editor.insertHtml(insertHtml);
    editor.restoreSelection();
  },
  handleDraftButton() {
    this.setState(
      {
        isDraft: true,
      },
      function() {
        this.updateBlogToServer();
      }
    );
  },
  handleDeleteButton() {
    this.setState(
      {
        isDeleted: true,
      },
      function() {
        this.updateBlogToServer();
      }
    );
  },
  handleSubmitButton() {
    this.setState(
      {
        isDraft: false,
      },
      function() {
        this.updateBlogToServer();
      }
    );
  },
  handlePostDateChange(e) {
    this.setState({
      publishDatetime: e.target.value,
    });
  },
  selectKeyvisual(e) {
    this.setState({
      keyvisualUrl: e.target.value,
    });
  },
  handleKeyvisualImageSelector() {
    this.setState({
      isModalImageSelectorActive: true,
      caller: "keyvisual",
    });
  },
  render() {
    return (
      <div className="mb-5 container col-lg-8">
        {this.state.isModalImageSelectorActive ? (
          <ModalImageSelector
            isActive={this.state.isModalImageSelectorActive}
            circleId={this.props.myCircle.id}
            closeModal={this.closeModal}
            selectPhoto={this.selectPhoto}
            selectKeyvisual={this.selectKeyvisual}
            caller={this.state.caller}
          />
        ) : (
          ""
        )}

        <div>
          <p>
            <label>
              <input
                type="radio"
                name="targetTypes[0]"
                value="1"
                checked={this.state.publicType === 1}
                onChange={() => this.setState({ publicType: 1 })}
              />
              &nbsp;<span>ブログ</span>
            </label>
          </p>
          <p>
            <label>
              <input
                type="radio"
                name="targetTypes[0]"
                value="2"
                checked={this.state.publicType === 2}
                onChange={() => this.setState({ publicType: 2 })}
              />
              &nbsp;<span>サークル内</span>
            </label>
          </p>
        </div>

        <input
          type="text"
          className="width-full form-control mt-4"
          placeholder="タイトル"
          value={this.state.title}
          style={{
            borderRadius: "0",
            fontWeight: "bold",
            height: "50px",
            paddingLeft: "10px",
          }}
          onChange={this.handleTitleInput}
        />

        <div
          className="mt-3"
          style={{ display: "flex", alignItems: "center", background: "#fff" }}
        >
          <div
            className="small"
            style={{
              display: "inline-flex",
              width: "22%",
              paddingLeft: "10px",
            }}
            value={this.state.publishDatetime}
            onChange={this.handlePublishDatetimeInput}
          >
            投稿日時
          </div>
          <div style={{ display: "inline-flex", width: "88%" }}>
            <input
              type="datetime-local"
              className="form-control "
              value={this.state.publishDatetime}
              onChange={this.handlePostDateChange}
              style={{ borderRadius: "0", width: "100%", boxShadow: "none" }}
            />
          </div>
        </div>
        <div
          className="mt-3"
          style={{ display: "flex", alignItems: "center", background: "#fff" }}
        >
          <div
            className="small"
            style={{
              display: "inline-flex",
              width: "22%",
              paddingLeft: "10px",
            }}
            value={this.state.publishDatetime}
            onChange={this.handlePublishDatetimeInput}
          >
            タグ
          </div>
          <div style={{ display: "inline-flex", width: "88%" }}>
            <input
              type="text"
              className="form-control "
              value={this.state.tags}
              onChange={this.handleTagsInput}
              placeholder="スペース区切り"
              style={{ borderRadius: "0", width: "100%", boxShadow: "none" }}
            />
          </div>
        </div>
        <div
          className="mt-3"
          style={{ display: "flex", alignItems: "center", background: "#fff" }}
        >
          <div
            className="small"
            style={{
              display: "inline-flex",
              width: "22%",
              paddingLeft: "10px",
            }}
            value={this.state.keyvisual_url}
            onChange={this.handlePublishDatetimeInput}
          >
            キービジュアル
          </div>
          <button
            className="mr-2 a-button a-button__top a-button__top--outline mb-2"
            onClick={this.handleKeyvisualImageSelector}
          >
            登録
          </button>
        </div>
        <div
          style={{ display: "flex", alignItems: "center", background: "#fff" }}
        >
          <div>
            <div>
              <img
                style={{ width: "100%" }}
                src={this.state.keyvisualUrl}
                alt=""
              />
            </div>
          </div>
        </div>

        <textarea
          id="content"
          className="js-editor"
          value={this.state.content}
        />

        <div className="d-flex justify-content-around mt-4">
          <button
            className="mr-2 a-button a-button__top a-button__top--outline mb-4"
            onClick={this.handleDeleteButton}
          >
            削除
          </button>
          <button
            className="mr-2 a-button a-button__top a-button__top--outline mb-4"
            onClick={this.handleDraftButton}
          >
            下書き
          </button>
          <button
            className="a-button a-button__top a-button--orange mr-2 mb-4"
            onClick={this.handleSubmitButton}
          >
            投稿
          </button>
        </div>
      </div>
    );
  },
});
